import {SnackbarController} from "./SnackbarController.ts";

export const reviewSnackbarController = new SnackbarController();
